module.exports = __webpack_public_path__ + "img/2.231f4366.png";